import Reveal from '@/components/base/Reveal';
import { latestFeed } from '@/mocks/homeData';

function LatestFeed() {
  return (
    <section id="latest" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl">
          <Reveal>
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div>
                <span className="inline-flex items-center gap-1.5 text-xs font-label text-primary-600 uppercase tracking-widest">
                  <i className="ri-refresh-line" />
                  Latest Updates
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">最新更新</h2>
                <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 font-label leading-relaxed">
                  刚刚整理好的条目索引，按时间倒序排列，封面驱动，先看封面再决定点不点。
                </p>
              </div>
              <a
                href="#top"
                className="inline-flex items-center gap-1 h-10 px-4 rounded-md border border-background-300 text-sm font-label text-foreground-800 hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap shrink-0"
              >
                回到顶部
                <i className="ri-arrow-up-line" />
              </a>
            </div>
          </Reveal>

          <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {latestFeed.map((item, index) => (
              <Reveal key={item.id} delay={index * 50}>
                <a
                  href="#top"
                  className="group block h-full rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
                >
                  <div className="relative w-full h-44 overflow-hidden">
                    <img
                      src={item.cover}
                      alt={`${item.title} 封面`}
                      title={`${item.title}`}
                      className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                    />
                    <span className="absolute top-3 left-3 inline-flex items-center h-6 px-2.5 rounded-full bg-secondary-500 text-background-50 text-[11px] font-label">
                      {item.district}
                    </span>
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                      {item.title}
                    </h3>
                    <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3">
                      <span className="flex items-center gap-1 text-xs font-label text-foreground-500">
                        <i className="ri-time-line" />
                        {item.time}
                      </span>
                      <span className="flex items-center gap-1 text-xs font-label text-foreground-800 group-hover:text-primary-600 transition-colors">
                        查看索引
                        <i className="ri-arrow-right-line" />
                      </span>
                    </div>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default LatestFeed;